<script setup>
import useAiChat from "@/composables/useAiChat";
import {onMounted} from "vue";
const props = defineProps(['needId']);
const emit = defineEmits(['done']);

const roundFormat = {
    answer: '',
};

const params = {
    url: '/chat-stream/get-match-response',
    roundFormat,
    addEvents: {
        'done': done
    }
}

const {
    question,
    loaderMessage,
    sendRequest,
} = useAiChat(params);

onMounted(() => {
    question.value = props.needId;
    sendRequest();
});

function done() {
    emit('done');
}
</script>

<template>
    <div class="need-page__loader">
        <div class="loader-spinner">
            <div class="loader-spinner__border"></div>
            <div class="loader-spinner__back"></div>
            <div class="loader-spinner__overlay"></div>
            <div class="loader-spinner__icon"></div>
        </div>
        {{loaderMessage}}
    </div>
</template>

<style scoped>

</style>
